// extracted by mini-css-extract-plugin
export default {"modalOverlay":"model-overlay_modalOverlay__9fHOC"};